import HeaderTab from "./Tab";
import { useLocation } from "react-router";

const HeaderTabSection = ({ menuItems }) => {
  let location = useLocation();

  let activeMenuItem = menuItems[0];
  menuItems.forEach((item) =>
    item.children.forEach((subitem) => {
      if (location.pathname === subitem.url) {
        activeMenuItem = item;
      }
    })
  );
  return (
    <>
      {menuItems.map((item, index) => (
        <HeaderTab
          item={item}
          key={index}
          isActive={activeMenuItem.id === item.id}
        />
      ))}
    </>
  );
};
export default HeaderTabSection;
